// extracted by mini-css-extract-plugin
module.exports = {"Link":"Purchases_Link__E5iGF","pending":"Purchases_pending__SJkdK","purchaseContainer":"Purchases_purchaseContainer__3fIeu","tblPurchase":"Purchases_tblPurchase__30Qtn"};